module.exports = __webpack_public_path__ + "img/binanceicon822x.9b2c8412.png";